<template>
  <div :key="cartStore.items.length">
    <CartButton
      class="size-5"
      :items="cartStore.items?.length"
      :count="cartStore.updated && cartStore.getTotalTicketsInCart"
      @click="openModal()" />
    <CartErrorModal />
  </div>

  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="relative z-50 text-foreground" @close="closeModal">
      <DialogBackground />

      <div class="fixed inset-0 overflow-y-auto overflow-x-hidden z-50">
        <div class="h-full sm:h-auto sm:min-h-full flex justify-end items-start text-center text-foreground">
          <TransitionChild
            as="template"
            enter="transform transition ease-in-out duration-500 lg:duration-700"
            enter-from="translate-x-full"
            enter-to="translate-x-0"
            leave="transform transition ease-in-out duration-500 lg:duration-700"
            leave-from="translate-x-0"
            leave-to="translate-x-full">
            <DialogPanel
              class="w-full h-dvh sm:max-w-[400px] transform bg-neutral-foreground text-left align-middle shadow-xl transition-all text-foreground px-8 py-10 flex flex-col gap-6 overflow-y-auto">
              <DialogTitle as="h3" class="text-lg font-medium leading-6 flex justify-between">
                <span class="flex gap-2"> <ShoppingCartIcon class="h-6" /> {{ $t("My shopping cart") }} </span>
                <button @click="closeModal">
                  <XMarkIcon class="h-5" />
                </button>
              </DialogTitle>
              <template v-if="cartStore.items?.length">
                <CartReservation />
                <div class="h-[1px] bg-border"></div>
                <CartItems />
                <ReservationTotals class="flex-none" />
                <RouterLink
                  to="/checkout"
                  :class="!cartStore.timeLeft && 'pointer-events-none'"
                  data-testid="continue-to-checkout">
                  <Button :disabled="!cartStore.timeLeft" class="w-full gap-1 items-center h-12">
                    {{ $t("Continue to checkout") }}
                    <ChevronRightIcon class="size-4" />
                  </Button>
                </RouterLink>
              </template>
              <div v-else class="p-4 my-4 bg-brand-button text-brand-text rounded flex gap-2">
                <span>{{ $t("There are no items in your shopping cart right now...") }}</span>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import CartReservation from "@/components/cart/CartReservation.vue";
import CartItems from "@/components/cart/CartItems.vue";
import ReservationTotals from "@/components/reservations/ReservationTotals.vue";

import CartButton from "@/components/cart/CartButton.vue";
import CartErrorModal from "@/components/cart/CartErrorModal.vue";
import { useCartStore } from "@/store/cart.ts";

import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from "@headlessui/vue";

import { RouterLink } from "vue-router";
import { ShoppingCartIcon, XMarkIcon, ChevronRightIcon } from "@heroicons/vue/24/outline";
import { ref, watch } from "vue";
import DialogBackground from "@/components/shared/DialogBackground.vue";
import { Button } from "@xs2event/js-lib/components";

const cartStore = useCartStore();

const isOpen = ref(false);
const openModal = () => {
  isOpen.value = true;
  cartStore.updates = [];
};

watch(
  () => cartStore.updates,
  (newValue, oldValue) => {
    if (newValue.length == oldValue.length) return;
    openModal();
  }
);

const closeModal = () => (isOpen.value = false);
</script>
